import React from 'react';
import { getAssetPath } from '../../utils/publicPath';

const DefaultData = [
  {
    image: '/images/brand/brand-1.png'
  },
  {
    image: '/images/brand/brand-2.png'
  },
  {
    image: '/images/brand/brand-3.png'
  },
  {
    image: '/images/brand/brand-4.png'
  },
  {
    image: '/images/brand/brand-5.png'
  },
  {
    image: '/images/brand/brand-6.png'
  },
  {
    image: '/images/brand/brand-7.png'
  },
  {
    image: '/images/brand/brand-8.png'
  }
];

const BrandItem = ({ variant = 'default', items }) => {
  if (variant === 'mutawir') {
    const logos = Array.isArray(items) ? items : [];

    return (
      <>
        {logos.map((logo, index) => {
          const file = logo.file || logo.image;
          const name = logo.name || '';
          if (!file) {
            return null;
          }
          const src = getAssetPath(`/images/clients/${file}`);

          return (
            <div className="col-md-3 col-sm-4 col-6" key={index}>
              <div className="mutawir-client-logo" aria-label={name}>
                <img src={src} alt={name || 'Client logo'} />
              </div>
            </div>
          );
        })}
      </>
    );
  }

  return (
    <>
      {DefaultData.map((data, index) => (
        <div className="col-lg-3 col-6" key={index}>
          <div className="brand-grid">
            <img src={getAssetPath(data.image)} alt="Brand" />
          </div>
        </div>
      ))}
    </>
  );
};

export default BrandItem;
